import { Injectable } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class SettlementModalService {
  private translationText: any = {};
  private subscription = new Subscription();

  private readonly reportTypeOptions = [
    { report_type_name: 'Settlement History', report_type: 'settlement_history' },
    { report_type_name: 'Deduction from Sales', report_type: 'deduction_from_sales' },
    { report_type_name: 'Other Deductions', report_type: 'other_deductions' },
    { report_type_name: 'Deduction from Sales by ID', report_type: 'deduction_from_sales_by_id' },
    { report_type_name: 'Settlement History by ID', report_type: 'settlement_history_by_id' },
    { report_type_name: 'Settlement Summary', report_type: 'settlement_summary' }
  ];

  constructor(
    private _modalService: NzModalService,
    private _translateService: TranslateService
  ) {
    this.setTranslations();
  }

  private setTranslations(): void {
    this.subscription.add(
      this._translateService.get(['SETTLEMENTS']).subscribe((translation) => {
        this.translationText = translation.SETTLEMENTS || {};
      })
    );
  }

  getReportTypeOptions() {
    return this.reportTypeOptions;
  }

  async openDownloadRequestsModal(data?: any): Promise<NzModalRef<any>> {
    const { DownloadRequestsComponent } = await import(
      /* webpackPrefetch: true */ '../../invoice/modals/download-requests/download-requests.component'
    );


    const formattedData = {
      ...data,
      dropdownData: this.reportTypeOptions,
      tableData: data?.tableData || [],
      statusCount: {
        alreadyDownloaded: data?.tableData?.filter(item => item.status === 2)?.length || 0,
        toBeDownloaded: data?.tableData?.filter(item => item.status === 1)?.length || 0
      }
    };

    const modalData: any = {
      data: formattedData,
      module: "settlement"
    };

    return this._modalService.create({
      nzClosable: false,
      nzContent: DownloadRequestsComponent,
      nzComponentParams: {
        modalData
      },
      nzBodyStyle: { padding: '0', height: '100vh' },
      nzStyle: { top: '0', padding: '0' },
      nzFooter: null,
      nzWidth: '100vw',
    });
  }

  async openNoRequestModal(): Promise<NzModalRef<any>> {
    const { NoRequestComponent } = await import(
      /* webpackPrefetch: true */ '../../invoice/modals/no-request/no-request.component'
    );
    
    return this._modalService.create({
      nzContent: NoRequestComponent,
      nzClosable: false,
      nzBodyStyle: { padding: '0'},
      nzStyle: { top: '20%' },
      nzFooter: null,
      nzWidth: '450px',
    });
  }
} 